/*协议*/
import getTranslation from '@/locale/getTranslation'
export default {
  path: '/agreement',
  name: 'agreement',
  component: resolve => require(['@/views/agreement'], resolve),
  meta: {
    title: '协议'
  },
  children: [
    {
      path: '/',
      redirect: 'service'
    },
    {
      path: 'register',
      name: 'register',
      component: resolve => require(['@/views/agreement/register'], resolve),
      meta: {
        title: getTranslation('注册协议'),
        keepAlive: true
      }
    },
    {
      path: 'service',
      name: 'service',
      component: resolve => require(['@/views/agreement/service'], resolve),
      meta: {
        title: getTranslation('用户服务协议与隐私政策'),
        keepAlive: true
      }
    },
    {
      path: 'privacy-policy',
      name: 'privacy',
      component: resolve => require(['@/views/agreement/privacy'], resolve),
      meta: {
        title: getTranslation(`隐私策略`),
        keepAlive: true
      }
    },
    {
      path: 'live-streaming',
      name: 'live',
      component: resolve => require(['@/views/agreement/live'], resolve),
      meta: {
        title: getTranslation('2021年中国国际服务贸易交易会参展商直播协议'),
        keepAlive: true
      }
    },
    {
      path: '*',
      redirect: 'service'
    }
  ]
}
